export const LanguageMap = {
  ENGLISH: "en",
  KOREAN: "ko",
} as const;
